export const TrainingSectionAttemptStatus = {
  COMPLETED: "Completed",
  IN_PROGRESS: "In Progress",
  NOT_STARTED: "Not Started",
  PENDING: "Pending",
};

export const TrainingSectionAttemptStatusKey = {
  COMPLETED: "completed",
  IN_PROGRESS: "in_progress",
  NOT_STARTED: "not_started",
};

export const TrainingModuleStatusKey = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  DRAFT: "draft",
};

export const TrainingModuleStatus = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  DRAFT: "Draft",
};

export const TabNames = {
  COMPLETED_TRAININGS: "Completed Trainings",
  PENDING_TRAININGS: "Pending Trainings",
  DRAFT_TRAININGS: "Draft Trainings",
  ACTIVE_TRAININGS: "Active Trainings",
  INACTIVE_TRAININGS: "Inactive Trainings",
};

export const TrainingSectionTypeKey = {
  VIDEO: "s3_video",
  PPTX: "pptx",
  PDF: "pdf",
  DOCX: "docx",
};

export const TrainingStep = {
  CHOICE: "choice",
  LIBRARY: "library",
  MANUAL: "manual",
};

export const TabValues = {
  PENDING: "1",
  COMPLETED: "2",
};

export const ViewType = {
  LIST: "list",
  GRID: "grid",
};
